import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import {
  CloseOutlined,
  LeftOutlined,
  RightOutlined,
  CheckOutlined,
  LockOutlined,
} from "@ant-design/icons";
import "./style.scss";
import Storelist from "../../Store/Actions";
import moment from "moment";
import Api from "../../Utils/Api.js";
import useApiPost from "../../Hooks/usePost.js";
import { BASE_URL_API } from "../../appconfig.js";
import { toast } from "react-toastify";

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const SlotAttendance = ({ data, getSlots }) => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(() => {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  });
  const [currentKey, setCurrentKey] = useState(null);
  const [holidayToggle, setHolidayToggle] = useState(false);

  const { PageStore, setSlotModal, setLoading } = Storelist();
  const { setOrRevokeAttendance } = Api();
  const checkServiceRequest = useApiPost();

  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const pad2 = (n) => String(n).padStart(2, "0");
  const dateOnly = (value) => String(value || "").split("T")[0];
  const toKey = (y, m, d) => `${y}-${pad2(m + 1)}-${pad2(d)}`;

  const allowedDateKeys = (data || []).reduce((acc, item) => {
    acc.add(dateOnly(item?.startTime));
    return acc;
  }, new Set());

  useEffect(() => {
    if (!PageStore?.slotPage) {
      setSelectedDates([]);
      setCurrentKey(null);
      setHolidayToggle(false);
    } else {
      setSlotData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PageStore?.slotPage]);

  const getHolidayNameFromItem = (item) => {
    if (!item) return "";
    const candidates = [
      item?.holidayname,
      item?.holidayName,
      item?.holiday_name,
      item?.holiday,
      item?.HolidayName,
      item?.name,
      item?.occasion,
      item?.festival,
      item?.holidayDescription,
      item?.description,
    ];
    const found = candidates.find(
      (v) => typeof v === "string" && v.trim() !== ""
    );
    return found ? found : "";
  };

  const setSlotData = () => {
    const initial = (data || []).map((item) => {
      const apiHoliday =
        item?.isholiday === 1 || item?.isholiday === true;
      const isOverridden =
        item?.isoverridden === 1 || item?.isoverridden === true;
      return {
        startTime: item?.startTime,
        isactive: apiHoliday ? 0 : 1,
        isholiday: apiHoliday ? 1 : 0,
        isoverridden: isOverridden ? 1 : 0,
        isgovtholiday:
          item?.isgovtholiday === 1 || item?.isgovtholiday === true ? 1 : 0,
        holidayName: getHolidayNameFromItem(item) || "",
        prevActive: item?.isactive,
      };
    });
    setSelectedDates(initial);
  };

  const getCellData = (d) => {
    const key = toKey(year, month, d);
    const record = selectedDates.find((s) => dateOnly(s?.startTime) === key);
    return { key, record };
  };

  const applyToggle = (key, markAsHoliday) => {
    if (!key) {
      setLoading(false);
      return;
    }
    const idx = selectedDates.findIndex((s) => dateOnly(s?.startTime) === key);
    let item;
    if (idx !== -1) {
      item = selectedDates[idx];
    } else {
      if (!allowedDateKeys.has(key)) {
        setLoading(false);
        return;
      }
      item = {
        startTime: `${key}T00:00:00`,
        isactive: 1,
        isholiday: 0,
        isoverridden: 0,
        holidayName: "",
        prevActive: 0,
      };
    }
    let nextItem;
    if (markAsHoliday) {
      if (item.isholiday) {
        nextItem = {
          ...item,
          isholiday: 0,
          isactive: 1,
        };
      } else {
        nextItem = {
          ...item,
          prevActive: item.isactive,
          isholiday: 1,
          isactive: 0,
          isoverridden: 1,
        };
      }
    } else {
      if (item.isholiday) {
        nextItem = {
          ...item,
          isholiday: 0,
          isactive: 1,
        };
      } else {
        nextItem = {
          ...item,
          isactive: item.isactive ? 0 : 1,
        };
      }
    }

    const updated =
      idx === -1
        ? [...selectedDates, nextItem]
        : selectedDates.map((s, i) => (i === idx ? nextItem : s));
    setSelectedDates(updated);
    setCurrentKey(null);
    setHolidayToggle(false);
    setLoading(false);

    setOrRevokeAttendance({
      branchId: localStorage.getItem("BrId"),
      attendanceDates: [
        {
          startTime: nextItem?.startTime,
          isactive: nextItem?.isactive ? 1 : 0,
          isholiday: nextItem?.isholiday ? 1 : 0,
          isoverridden: 1,
        },
      ],
    });
  };

  const checkServiceExist = (key, record, isHoliday = false) => {
    setLoading(true);
    const willDisable =
      (record?.isactive || 0) && (isHoliday ? !record?.isholiday : true);
    if (willDisable) {
      setCurrentKey(key);
      setHolidayToggle(isHoliday);
      checkServiceRequest.Postdata(
        `${BASE_URL_API()}getBranchRequestByDate`,
        true,
        {
          branch: localStorage.getItem("BrId"),
          RequestDate: record?.startTime,
        }
      );
    } else {
      applyToggle(key, isHoliday);
    }
  };

  useEffect(() => {
    if (checkServiceRequest.data !== null) {
      if (checkServiceRequest.data.status === 200) {
        if (checkServiceRequest?.data?.body?.data) {
          setLoading(false);
          toast.warn(checkServiceRequest?.data?.body?.message, {
            position: "top-center",
          });
        } else {
          applyToggle(currentKey, holidayToggle);
        }
        checkServiceRequest.setData(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkServiceRequest?.data, checkServiceRequest?.error]);

  const handleHolidayClick = (d, e) => {
    e.stopPropagation();
    const { key, record } = getCellData(d);
    if (!allowedDateKeys.has(key)) return;
    checkServiceExist(key, record, true);
  };

  const prevMonth = () => setCurrentMonth(new Date(year, month - 1, 1));
  const nextMonth = () => setCurrentMonth(new Date(year, month + 1, 1));

  const cells = [];
  const offset = (new Date(year, month, 1).getDay() + 6) % 7;
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  return (
    <Modal
      open={PageStore?.slotPage}
      footer={null}
      width={760}
      className="modal-container"
      onCancel={() => setSlotModal()}
      closeIcon={
        <CloseOutlined
          style={{
            border: "1px solid black",
            borderRadius: "10px",
            padding: "4px",
            color: "black",
            fontSize: "18px",
            backgroundColor: "white",
          }}
        />
      }
      styles={{ body: { padding: "20px 24px 16px" } }}
    >
      <div className="slot-settings">
        <div className="slot-header">
          <span className="slot-title">Service Slots</span>
        </div>

        <div className="calendar-nav">
          <button type="button" className="nav-btn" onClick={prevMonth}>
            <LeftOutlined />
          </button>
          <span className="month-label">
            {moment(currentMonth).format("MMMM YYYY")}
          </span>
          <button type="button" className="nav-btn" onClick={nextMonth}>
            <RightOutlined />
          </button>
        </div>

        <div className="calendar-weekdays">
          {WEEKDAYS.map((w) => (
            <span key={w} className="weekday">
              {w}
            </span>
          ))}
        </div>

        <div className="calendar-grid">
          {cells.map((d, i) => {
            if (d === null) {
              return <div key={`blank-${i}`} className="calendar-cell blank" />;
            }
            const { key, record } = getCellData(d);
            const allowed = allowedDateKeys.has(key);
            const isHoliday = !!record?.isholiday;
            const isGovtHoliday =
              record?.isgovtholiday === 1 || record?.isgovtholiday === true;
            const isActive = !!record?.isactive;
            const holidayName = record?.holidayName || "";
            const cellType =
              !allowed
                ? "disabled"
                : isHoliday && !isActive
                  ? "holiday"
                  : isGovtHoliday && isActive
                    ? "festival"
                    : isActive
                      ? "available"
                      : "closed";
            const todayMatch = new Date();
            const startOfToday = new Date(
              todayMatch.getFullYear(),
              todayMatch.getMonth(),
              todayMatch.getDate()
            );
            const cellDate = new Date(year, month, d);
            const isPast = cellDate.getTime() <= startOfToday.getTime();
            const dayLabel =
              !allowed
                ? isPast
                  ? "Completed"
                  : "Upcoming"
                : isHoliday && !isActive
                  ? holidayName || "Holiday"
                  : isGovtHoliday && isActive
                    ? holidayName || "Festival"
                    : isActive
                      ? "Working Day"
                      : "";
            return (
              <div
                key={key}
                className={`calendar-cell ${cellType}`}
              >
                <span className="cell-date">{d}</span>
                <span className="cell-state">
                  {isHoliday ? (
                    <LockOutlined />
                  ) : isActive ? (
                    <CheckOutlined />
                  ) : (
                    <span className="closed-dot" />
                  )}
                </span>
                {dayLabel && (
                  <span className="cell-holiday-name">{dayLabel}</span>
                )}
                {allowed && (
                  <button
                    type="button"
                    className={`holiday-action ${cellType}`}
                    onClick={(e) => handleHolidayClick(d, e)}
                  >
                    {isHoliday ? "Unmark Holiday" : "Mark Holiday"}
                  </button>
                )}
              </div>
            );
          })}
        </div>

        <div className="slot-legend">
          <span className="legend-item available">
            <i className="dot" />
            <CheckOutlined className="legend-icon" /> Working Day
          </span>
          <span className="legend-item festival">
            <i className="dot" />
            <CheckOutlined className="legend-icon" /> Festival Working Day
          </span>
          <span className="legend-item holiday">
            <i className="dot" />
            <LockOutlined className="legend-icon" /> Holiday
          </span>
          <span className="legend-item closed">
            <i className="dot" />
            Closed
          </span>
        </div>
      </div>
    </Modal>
  );
};

export default SlotAttendance;